/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.ComponentKeywordsViewEdit";
        class ComponentKeywordsViewEdit extends Widgets.ComponentKeywordsBase {
            constructor(core, container, parent) {
                super(core, container, parent);
                this._mode = WPTNamespace.MetadataEditors.KeywordEditMode.VIEW;
                // Shorthand
                this._docType = null;
                this._cacheUpdated = () => {
                    if (this._core.OBHelper.KeywordTypesLoaded && this._core.OBHelper.DownloadDocumentTypesLoaded)
                        this._cacheReady = true;
                };
                this._sanityCheckRequest = (request) => {
                    if (!request.hasOwnProperty('Document') || (request.Document == null))
                        return false;
                    return true;
                };
                this._servicePendingRequest = () => {
                    this._log.info('ComponentKeywordsViewEdit::_servicePendingRequest');
                    // Nothing to do if nothing pending
                    if (!this._requestPending)
                        return;
                    // Bump pending request to active status
                    this._requestActive = this._requestPending;
                    this._requestPending = null;
                    this._listRoot.innerHTML = '';
                    this._mode = this.ActiveRequest.Mode;
                    // Need a document type
                    this._docType = this._core.OBHelper.DownloadDocumentTypeMap[this.ActiveRequest.Document.DocType.Name];
                    if (!this._docType) {
                        console.error(`ComponentKeywordsViewEdit invalid doc type requested: '${this.ActiveRequest.Document.DocType.Name}''`);
                        return;
                    }
                    this._setUserKeywordPrivilege();
                    this._buildUI();
                };
                this._setUserKeywordPrivilege = () => {
                    this._log.info('ComponentKeywordsViewEdit::_setUserKeywordPrivilege');
                    // Use LEAST permissive option
                    this._userCanAccessRestrictedKeys = false;
                    let dt = this._core.OBHelper.DocumentTypesById[this.ActiveRequest.Document.DocType.Id];
                    if (dt && dt.hasOwnProperty('Privileges') && (dt.Privileges))
                        this._userCanAccessRestrictedKeys = dt.Privileges.AccessRestrictedKeywords;
                };
                this._buildUI = () => {
                    this._log.info('ComponentKeywordsViewEdit::_buildUI');
                    // Need to build a keyword record for every type on the doc type, and more if the document has several
                    this._groupMap = {};
                    // Want a sorted list of keyword record types
                    let typeRecs = ((this._docType.hasOwnProperty('KeywordRecords')) && (this._docType.KeywordRecords != null))
                        ? this._docType.KeywordRecords.sort((r1, r2) => { return Widgets.ComponentKeywordsBase._sortMap[r1.Type] - Widgets.ComponentKeywordsBase._sortMap[r2.Type]; })
                        : [];
                    if ((typeRecs.length == 0) || (typeRecs[0].Type != 'StandAlone'))
                        typeRecs.unshift(this._createStandaloneRecordType());
                    // Insert document-type level autofill into type record definition
                    let afks = (this._docType.hasOwnProperty('AutoFillKeywordSet') && (this._docType.AutoFillKeywordSet != null)) ? this._docType.AutoFillKeywordSet : null;
                    // Loop through our type records to see if we have any "real" records
                    typeRecs.forEach(typeRec => {
                        // Skip to next iteration if we are explicitly not included or excluded
                        if (this._requestActive.IncludeGroups.length > 0) {
                            if (this._requestActive.IncludeGroups.indexOf(typeRec.Name) == -1)
                                return;
                        }
                        else if (this._requestActive.ExcludeGroups.length > 0) {
                            if (this._requestActive.ExcludeGroups.indexOf(typeRec.Name) > -1)
                                return;
                        }
                        // Skip to next iteration if no keywords in this group type
                        if (!WPTNamespace.MetadataEditors.KeywordGroupWrapper.HasKeywords(typeRec, this._requestActive.IncludeKeywords, this._requestActive.ExcludeKeywords))
                            return;
                        // Tag any AFKS primary with doc type AFKS - so doc type set overrides keyword type set if both have an autofill
                        if (afks)
                            typeRec.KeywordTypes.forEach(kwt => { if (kwt.Name == afks.PrimaryKeyword.Name)
                                kwt.AutofillKeywordSetId = afks.Id; });
                        let suppressHeading = ((typeRecs.length == 1) && (typeRec.Type == "StandAlone")) ? true : false;
                        let realRecs = this.ActiveRequest.Document.KeywordRecords.filter(rec => (rec.Name == typeRec.Name));
                        if (realRecs.length > 0) {
                            realRecs.forEach(realRec => {
                                let id = Widgets.ComponentKeywordsBase.CounterString;
                                let recordWrapper = new WPTNamespace.MetadataEditors.KeywordGroupWrapper(this._core, this._form, this._listRoot, id, typeRec, realRec, this.Mode, this._userCanAccessRestrictedKeys, suppressHeading, this.ActiveRequest.SimpleEditors);
                                recordWrapper.AddCallback = this._groupAddCallback;
                                recordWrapper.RemoveCallback = this._groupRemoveCallback;
                                recordWrapper.CheckForRemoveCallback = this._checkGroupRemovalAllowed;
                                this._groupMap[id] = recordWrapper;
                            });
                        }
                        else {
                            let id = Widgets.ComponentKeywordsBase.CounterString;
                            let recordWrapper = new WPTNamespace.MetadataEditors.KeywordGroupWrapper(this._core, this._form, this._listRoot, id, typeRec, null, this.Mode, this._userCanAccessRestrictedKeys, suppressHeading, this.ActiveRequest.SimpleEditors);
                            recordWrapper.AddCallback = this._groupAddCallback;
                            recordWrapper.RemoveCallback = this._groupRemoveCallback;
                            recordWrapper.CheckForRemoveCallback = this._checkGroupRemovalAllowed;
                            this._groupMap[id] = recordWrapper;
                        }
                    });
                    // Callback if we are showing nothing
                    if ((Object.keys(this._groupMap).length == 0) && (this.NoKeysToDisplayCallback))
                        this.NoKeysToDisplayCallback();
                };
                this._checkGroupRemovalAllowed = (groupWrapper) => {
                    this._log.info('ComponentKeywordsViewEdit::_checkGroupRemovalAllowed');
                    let encountered = 0;
                    for (let id in this._groupMap) {
                        if (this._groupMap[id].RecordType.Name == groupWrapper.RecordType.Name)
                            encountered++;
                    }
                    if (encountered > 1)
                        return true;
                    else
                        return false;
                };
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._core.OBHelper.LoadDownloadDocumentTypes(this._cacheUpdated);
            }
            get ActiveRequest() {
                return this._requestActive;
            }
            get Mode() {
                return this._mode;
            }
            set Mode(value) {
                if (this._log.isTraceEnabled()) {
                    this._log.trace(`Setting edit mode to ${value}`);
                }
                if (this._mode == value)
                    return;
                if ((value != WPTNamespace.MetadataEditors.KeywordEditMode.EDIT) && ((value != WPTNamespace.MetadataEditors.KeywordEditMode.VIEW)))
                    return;
                this._mode = value;
                for (let groupId in this._groupMap) {
                    this._groupMap[groupId].Mode = value;
                }
            }
        }
        Widgets.ComponentKeywordsViewEdit = ComponentKeywordsViewEdit;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
